module.exports = __webpack_public_path__ + "fonts/ArnoProBold.woff2";